import cx from "classnames"
import React from "react"
import * as css from "./Overflow.module.css"

function Overflow({ className, children }) {
  return <div className={cx(css.root, className)}>{children}</div>
}

export default Overflow
